import { LogLevel } from '@azure/msal-browser';
import { Policy } from '../enums/policy.enum';
import { TenantId } from '../enums/tenant-id.enum';
import { ClientB2C } from '../types/ClientB2C';
import { ClientEnvironment } from '../types/ClientEnvironment';

type TenantName = 'testulplatform';
type AuthorityDomainTld = 'b2clogin.com';
type TenantDomainTld = 'onmicrosoft.com';

declare global {
	namespace NodeJS {
		interface ProcessEnv {
			GITHUB_AUTH_TOKEN: string;
			NODE_ENV: 'development' | 'production';
			PORT?: string;
			PWD: string;
			SERVICEBUS_HOSTNAME?: string;
			QUEUE_NAME?: string;
			AZURE_TENANT_ID?: string;
			AZURE_CLIENT_ID?: string;
			AZURE_CLIENT_SECRET?: string;
		}
	}
}

export const b2c: ClientB2C = {
	logLevel: LogLevel.Warning,
	clientId: '5150b685-5426-4641-86cf-f6cb1b24052a',
	tenantId: TenantId.Staging,
	tenantDomain: `testulplatform.onmicrosoft.com`,
	authorityDomain: 'testulplatform.b2clogin.com',
	policies: {
		[Policy.SignUpSignIn]: 'B2C_1A_Signup_Signin_Staging',
		[Policy.ResetPassword]: 'B2C_1A_Password_Reset_Staging',
		[Policy.EditProfile]: 'B2C_1A_Edit_Profile_Staging',
	},
	redirects: {
		login: '/auth/sign-in',
		logout: '/auth/sign-out',
	},
	scope: 'https://testulplatform.onmicrosoft.com/case-management-qa/Read openid profile offline_access', // Important - Include offline_access to also request a refresh token
	scopes: {
		read: 'https://testulplatform.onmicrosoft.com/case-management-qa/Read',
		write: 'https://testulplatform.onmicrosoft.com/case-management-qa/Write',
	},
};

export const protectedResourceMap = new Map<string, string[]>([
	[
		'https://api-cm-qa-ncus.azurewebsites.net/v1/*',
		['https://testulplatform.onmicrosoft.com/case-management-qa/Read'],
	],
	// ['/fieldsprinklertesting/', [b2c.scopes.read]],
	// ['https://sentinel.qa.ul.com/*', [b2c.scopes.read]],
	// ['/api/*', [b2c.scopes.write]],
]);

export const environment: ClientEnvironment = {
	production: false,
	uLSubscriptionKey: '3572d602c46b449c8bca9cb8504f6b18',
	baseUrl: 'https://di-staging.ulplatform.com/tic/casemanagement/v1/',
	getLocationUrl: 'location',
	getCategoryUrl: 'Category',
	getCaseListUrl: 'Case',
	getCaseDetailsUrl: 'Case',
	saveCaseUrl: 'case/SaveCase',
	uploadFileUrl: 'case/UploadFile',
	createCaseUrl: 'case/CreateCase',
	getCommentsUrl: 'case/comments',
	getContactInfoUrl: 'user/getuserinfo',
	downloadAttachment: 'Attachments/Download',
	createCommentsAttachments: 'case/SaveCommentAndAttachment',
};
